// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Header from './Header';
import SkiAreasMap from './SkiAreasMap';
import ResortDetail from './ResortDetail';
import Leaderboard from './Leaderboard';
import Profile from './Profile';
import About from './About';
import './App.css';

// Component to handle CSS class management based on route
const PageClassManager = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove any existing page classes
    document.body.classList.remove('map-page', 'resort-page', 'leaderboard-page', 'about-page', 'profile-page');

    // Add appropriate class based on current route
    if (location.pathname === '/') {
      document.body.classList.add('map-page');
    } else if (location.pathname.startsWith('/resort/')) {
      document.body.classList.add('resort-page');
    } else if (location.pathname === '/leaderboard') {
      document.body.classList.add('leaderboard-page');
    } else if (location.pathname === '/about') {
      document.body.classList.add('about-page');
    } else if (location.pathname === '/profile') {
      document.body.classList.add('profile-page');
    }
    
    // Track pageview in GA4
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      });
    }

    // Cleanup function to remove classes when component unmounts
    return () => {
      document.body.classList.remove('map-page', 'resort-page', 'leaderboard-page', 'about-page', 'profile-page');
    };
  }, [location.pathname, location.search]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <PageClassManager />
          <Routes>
            <Route path="/" element={<SkiAreasMap />} />
            <Route path="/resort/:slug" element={<ResortDetail />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;